(function () {
  function injectTOS() {
    var checkoutArea = document.querySelector('[data-rebuy-component="checkout-area"]');
    if (!checkoutArea || checkoutArea.querySelector('.rebuy-tos-wrapper')) return;

    var rebuyCheckoutBtn = checkoutArea.querySelector('.rebuy-cart__checkout-button:not(.rebuy-tos-checkout-btn)');
    if (!rebuyCheckoutBtn) return;

    var isChecked = sessionStorage.getItem('tos_agreement') === 'true';

    var tosWrapper = document.createElement('div');
    tosWrapper.className = 'rebuy-tos-wrapper';
    tosWrapper.innerHTML =
      '<div class="rebuy-tos-field">' +
        '<input class="rebuy-tos-checkbox" type="checkbox" id="rebuy_tos_agreement"' + (isChecked ? ' checked' : '') + '>' +
        '<label class="rebuy-tos-label" for="rebuy_tos_agreement">' +
          'I have read &amp; agree to the current version of evanhealy\'s ' +
          '<a href="https://www.evanhealy.com/pages/terms-of-use" target="_blank">Terms of Use</a> and ' +
          '<a href="https://www.evanhealy.com/pages/privacy-policy" target="_blank">Privacy Policy</a>.' +
        '</label>' +
      '</div>' +
      '<p class="rebuy-tos-error">Please agree to the terms and conditions before proceeding to checkout</p>' +
      '<button type="button" class="rebuy-button rebuy-cart__checkout-button block rebuy-tos-checkout-btn">' +
        '<span>CHECKOUT</span>' +
        '<div class="loading-overlay__spinner hidden">' +
          '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
            '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
          '</svg>' +
        '</div>' +
      '</button>';

    checkoutArea.insertBefore(tosWrapper, rebuyCheckoutBtn);

    var checkbox = tosWrapper.querySelector('#rebuy_tos_agreement');
    var errorMsg = tosWrapper.querySelector('.rebuy-tos-error');
    var customBtn = tosWrapper.querySelector('.rebuy-tos-checkout-btn');

    checkbox.addEventListener('change', function () {
      sessionStorage.setItem('tos_agreement', this.checked ? 'true' : 'false');
      if (this.checked) {
        errorMsg.classList.remove('is-visible');
      }
    });

    customBtn.addEventListener('click', function () {
      if (!checkbox.checked) {
        errorMsg.classList.add('is-visible');
        return;
      }
      if (customBtn.getAttribute('aria-disabled') === 'true') return;
      sessionStorage.setItem('tos_agreement', 'true');
      customBtn.setAttribute('aria-disabled', 'true');
      customBtn.classList.add('loading');
      customBtn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      rebuyCheckoutBtn.click();
    });
  }

  document.addEventListener('rebuy:smartcart.ready', function () {
    var cart = document.getElementById('rebuy-cart');
    if (!cart) return;

    var debounceTimer;
    new MutationObserver(function () {
      if (!document.querySelector('[data-rebuy-component="checkout-area"] .rebuy-tos-wrapper')) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(injectTOS, 50);
      }
    }).observe(cart, { childList: true, subtree: true });

    injectTOS();
  });
})();
